module.exports = __webpack_public_path__ + "hinted-Montserrat-SemiBold.47accc0338dc094651e8.ttf";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-SemiBold.ttf
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-SemiBold.ttf
// module chunks = 1